import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const HeartFill = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.error.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M16.0012 6.03804C19.1332 3.22667 23.9732 3.32 26.99 6.34315C30.0069 9.36629 30.1105 14.1827 27.3046 17.324L15.9997 28.6467L4.69501 17.324C1.88923 14.1827 1.99411 9.35868 5.00965 6.34315C8.02859 3.3242 12.8601 3.22249 16.0012 6.03804Z"
        fill={color}
      />
    </svg>
  );
};

export default HeartFill;
